document.addEventListener('turbolinks:load', () => {
    const guideGuestPlayPause = document.getElementById("guideGuestPlayPause")
    const sgPreviewStationVideo = document.getElementById("sgPreviewStationVideo")
    const sgPreviewStationAudio = document.getElementById("sgPreviewStationAudio")
    const guestStationPreviewLandscapeVideo = document.getElementById("guestStationPreviewLandscapeVideo")
    const guestStationPreviewPortraitVideo = document.getElementById("guestStationPreviewPortraitVideo")

    const previewGuidedProgress = document.getElementById("previewGuidedProgress")
    const previewGuidedProgressDot = document.getElementById("previewGuidedProgressDot")
    const previewGuestProgressBar = document.getElementById("previewGuestProgressBar")
    const previewGuestProgressTime = document.getElementById("previewGuestProgressTime")

    const guidedMicButton = document.getElementById('guidedMicButton')

    let guide_media
    let guest_media

    let mousedown = false

    if(guideGuestPlayPause !== null && (sgPreviewStationVideo !== null || sgPreviewStationAudio !== null)){
        guide_media = sgPreviewStationVideo || sgPreviewStationAudio
        // only exists for videos, audio is present only once on guide screen
        guest_media = guestStationPreviewLandscapeVideo || guestStationPreviewPortraitVideo
        guideGuestPlayPause.addEventListener('click', togglePlay)
        guide_media.addEventListener("play", updateToggleButton)
        guide_media.addEventListener("pause", updateToggleButton)
        guide_media.addEventListener("timeupdate", handleProgress)

        previewGuidedProgress.parentElement.addEventListener("mousedown", (e) => {mousedown = true; scrub(e)});
        previewGuidedProgress.parentElement.addEventListener("mousemove", (e) => mousedown && scrub(e));
        document.addEventListener("mouseup", () => (mousedown = false)); //sets mousedown to false independent of mouse position

        // initially start the media by JS to avoid a media is loaded multiple times because of turbolink
        if (guide_media.dataset.autoplay === "true"){
            guide_media.play()
            if (guest_media && !guide_media.paused){ // only exists for videos
                guest_media.play()
            }
            toggleMicButton()
        }
    }

    function togglePlay() {
        if (guide_media.paused || guide_media.ended) {
            guide_media.play()
            if (guest_media){ // only exists for videos
                guest_media.play()
            }
        } else {
            guide_media.pause()
            if (guest_media) { // only exists for videos
                guest_media.pause()
            }
        }
    }

    //To change the appearance of the MicButton, when changing from play to paused or other way round
    function toggleMicButton(){
        if (guide_media.paused || guide_media.ended) {
            guidedMicButton.classList.remove('bg-grayDisabledButton')
            if (guidedMicButton.dataset.invisible === "true"){
                guidedMicButton.classList.add('opacity-0')
            } else {
                guidedMicButton.classList.add('bg-blueGuideUi')
            }
        } else {
            guidedMicButton.classList.remove('opacity-0')
            guidedMicButton.classList.remove('bg-blueGuideUi')
            guidedMicButton.classList.add('bg-grayDisabledButton')
        }
    }

    function updateToggleButton() {
        let playSvg = guideGuestPlayPause.getElementsByTagName('svg')[0]
        let pauseSvg = guideGuestPlayPause.getElementsByTagName('svg')[1]
        if (guide_media.paused){
            playSvg.classList.remove('hidden')
            pauseSvg.classList.add('hidden')
        } else {
            playSvg.classList.add('hidden')
            pauseSvg.classList.remove('hidden')
        }
        toggleMicButton()

    }

    function handleProgress() {
        //if duration is not available, use duration = 100 as fallback, otherwise you get NaN
        let progressPercentage = Math.round((guide_media.currentTime / (parseFloat(guide_media.dataset.media_duration) || 100)) * 100)
        // the dataset accuracy is in seconds and the current time in ms, so currentTime could be 999ms bigger than duration
        if (progressPercentage > 100){
            progressPercentage = 100
        }
        previewGuidedProgress.value = progressPercentage

        previewGuidedProgress.innerHTML = `${progressPercentage}%`
        previewGuidedProgressDot.style.left = `${progressPercentage}%`
        if (previewGuestProgressBar && previewGuestProgressTime) {
            previewGuestProgressBar.value = progressPercentage
            previewGuestProgressTime.innerHTML = secondsToMinuteString(guide_media.currentTime)
        }
    }

    //sets the media to the time selected with the progress bar
    function scrub(e) {
        const rect = previewGuidedProgress.parentElement.getBoundingClientRect();
        const offsetX = event.pageX - rect.left - window.scrollX;
        const scrubTime = (offsetX / previewGuidedProgress.offsetWidth) * parseFloat(guide_media.dataset.media_duration);

        guide_media.currentTime = scrubTime;
    }

    //Takes the seconds and writes it in the format 'mm:ss'
    function secondsToMinuteString(seconds) {
        seconds = Math.floor(seconds)

        let minutes = Math.floor(seconds / 60)
        let remained_seconds = seconds % 60
        return `${minutes.toString().padStart(2, '0')}:${remained_seconds.toString().padStart(2, '0')}`
    }
})